import { combineReducers } from "redux";
import { ThunkAction } from "redux-thunk";
import storage from "redux-persist/lib/storage";
import currentApplication from "./currentApplicationReducer";
import customers from "./customerReducer";
import codeRefs from "./codeRefReducer";
import policies from "./policyReducer";
import products from "./productReducer";
import userInfos from "./userInfos/userInfosReducer";
import providers from "./providerReducer";
import payment from "./paymentReducer";
import search from "./searchReducer";
import verifiedAddresses from "./verifiedAddressReducer";
import auth from "./authReducer";
import { ActionType } from "../actions/actionTypes";

const appReducer = combineReducers({
  currentApplication,
  customers,
  codeRefs,
  policies,
  products,
  userInfos,
  providers,
  payment,
  search,
  verifiedAddresses,
  auth
});

const rootReducer = (state: AppState, action: ActionType) => {
  if (action.type === "CLEAR_AUTH") {
    storage.removeItem("persist:root");
    // @ts-ignore
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;

export type AppState = ReturnType<typeof appReducer>;

export type ThunkResult = ThunkAction<void, AppState, undefined, ActionType>;
